import { Modal } from 'antd';

import { useApplyReturnAsyncMutation } from '@app/api/Loyalty';
import type { ConfirmCancelPaymentWithBonusesModalProps } from '@app/components/RecordModal/components/RecordPayment/types';
import { CANCEL, SAVE } from '@app/constants';
import { useUserPrint } from '@app/hooks';
import { useNotification } from '@app/providers/NotificationProvider/NotificationContext';
import { handleCatchError } from '@app/services';

export const ConfirmCancelPaymentWithBonusesModal: React.FC<
  ConfirmCancelPaymentWithBonusesModalProps
> = ({
  isOpen,
  setIsOpen,
  recordId,
  getRecordInfoHandler,
  initTable,
  fetchPayments,
}) => {
  const [applyReturnAsync, { isLoading }] = useApplyReturnAsyncMutation();

  const { activeBranchId: ActiveBranchId } = useUserPrint();
  const { showNotification } = useNotification();

  const handleCancel = () => {
    setIsOpen(false);
  };

  const cancelPaymentWithBonuses = async () => {
    try {
      await applyReturnAsync({
        recordId,
        ActiveBranchId,
      }).unwrap();

      handleCancel();

      await getRecordInfoHandler();
      await initTable();
      await fetchPayments();
    } catch (error) {
      showNotification(handleCatchError(error));
    }
  };

  return (
    <Modal
      title="Подтверждение действия"
      okText={SAVE}
      cancelText={CANCEL}
      open={isOpen}
      onCancel={handleCancel}
      onOk={cancelPaymentWithBonuses}
      okButtonProps={{
        loading: isLoading,
      }}
      cancelButtonProps={{
        disabled: isLoading,
      }}
    >
      Вы действительно хотите отменить применение бонусов?
    </Modal>
  );
};
